export enum TextType {
  H0,
  H1,
  H2,
  H2bold,
  H3,
  H3alerts,
  H3regular,
  H4,
  H4officials,
  H4bold,
  H5,
  H5bold,
  H5boldspaced,
  H6,
  H6semiBold,
  H6regular,
  P0,
  P1,
  P2,
  P2Variable,
}
export enum TextSize {
  default,
  large,
}
export enum TextSpacing {
  default,
  large,
}
export enum TextKerning {
  default,
  large,
}

export interface IProps {
  type?: TextType;
  text: string | number;
  size?: TextSize;
  color?: string;
  rowSpacing?: TextSpacing;
  kerning?: TextKerning;
  userSelect?: boolean;
  className?: string;
}
export interface IStyled {
  type: TextType;
  size: TextSize;
  rowSpacing: TextSpacing;
  kerning: TextKerning;
  userSelect: boolean;
}
